import Vue from 'vue'
// TODO: Replace vue-toasted with something else
import VueToasted from 'vue-toasted'

Vue.use(VueToasted)
